import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ServicioSesion } from '@app/services/sesion/sesion.service';
import Swal from 'sweetalert2';

/**
 * Factory que devuelve un guard que solo permite el acceso
 * si el rol activo es de alguno de los tipos indicados ('GLOBAL' | 'EQUIPO' | 'LIGA').
 *
 * Uso en rutas:
 *   canActivate: [tipoRolGuard('EQUIPO')]
 *   canActivate: [tipoRolGuard(['GLOBAL', 'LIGA'])]
 */
export function tipoRolGuard(tipoRequerido: 'GLOBAL' | 'EQUIPO' | 'LIGA' | Array<'GLOBAL' | 'EQUIPO' | 'LIGA'>): CanActivateFn {
  return () => {
    const sesion = inject(ServicioSesion);
    const router = inject(Router);

    const rolActivo = sesion.getRolActivo();
    const tiposPermitidos = Array.isArray(tipoRequerido) ? tipoRequerido : [tipoRequerido];

    if (rolActivo?.tipo && tiposPermitidos.includes(rolActivo.tipo as 'GLOBAL' | 'EQUIPO' | 'LIGA')) {
      return true;
    }

    Swal.fire({
      icon: 'warning',
      title: 'Acceso restringido',
      text: 'No estás autorizado para ver esta sección.',
      timer: 3000,
      showConfirmButton: false,
    });

    return router.parseUrl('/main/dashboard');
  };
}
